export default function FieldInfoTemplate(data) {
    //language=HTML
    return `
        <div class="w-100 h-100">
            <table class="table table-bordered mb-0">
                <tbody>
                <tr>
                    <th class="p-1" scope="row" style="width: 30%;vertical-align: middle;">ID</th>
                    <td class="p-1"><input class="w-100 py-1 px-2" type="text" value='${data.fieldId}'></td>
                </tr>
                <tr>
                    <th class="p-1" scope="row" style="width: 30%;vertical-align: middle;">Table</th>
                    <td class="p-1"><input class="w-100 py-1 px-2" type="text" value='${data.table}'></td>
                </tr>
                <tr>
                    <th class="p-1" scope="row" style="width: 30%;vertical-align: middle;">Column</th>
                    <td class="p-1"><input class="w-100 py-1 px-2" type="text" value='${data.column}'></td>
                </tr>
                <tr>
                    <th class="p-1" scope="row" style="width: 30%;vertical-align: middle;">References Table</th>
                    <td class="p-1"><input class="w-100 py-1 px-2" type="text" value='${data.refTable}'></td>
                </tr>
                <tr>
                    <th class="p-1" scope="row" style="width: 30%;vertical-align: middle;">Arabic</th>
                    <td class="p-1"><input class="w-100 py-1 px-2" type="text" value='${data.arabic}'></td>
                </tr>
                <tr>
                    <th class="p-1" scope="row" style="width: 30%;vertical-align: middle;">English</th>
                    <td class="p-1"><input class="w-100 py-1 px-2" type="text" value='${data.english}'></td>
                </tr>
                <tr>
                    <th class="p-1" scope="row" style="width: 30%;vertical-align: middle;">NamaRep.name</th>
                    <td class="p-1"><input class="w-100 py-1 px-2" type="text" value='${data.namaRep}'></td>
                </tr>
                <tr>
                    <th class="p-1" scope="row" style="width: 30%;vertical-align: middle;">Allowed Values</th>
                    <td class="p-1"><input class="w-100 py-1 px-2" type="text" value='${data.allowedValues}'></td>
                </tr>
                <tr>
                    <th class="p-1" scope="row" style="width: 30%;vertical-align: middle;">$F{columnName}</th>
                    <td class="p-1"><input class="w-100 py-1 px-2" type="text" value='${data.fColumn}'></td>
                </tr>
                <tr>
                    <th class="p-1" scope="row" style="width: 30%;vertical-align: middle;">$F{NamaRep.translate}</th>
                    <td class="p-1"><input class="w-100 py-1 px-2" type="text" value='${data.namaRepTranslate}'></td>
                </tr>
                <tr>
                    <th class="p-1" scope="row" style="width: 30%;vertical-align: middle;">Enum Type Name</th>
                    <td class="p-1"><input class="w-100 py-1 px-2" type="text" value='${data.enumTypeName}'></td>
                </tr>
                </tbody>
            </table>
        </div>`;
}